import React from 'react';

const Projects = () => (
  <section id="projects">
    <div className="wrap">
      <div className="eyebrow">
        <span className="prompt">$</span> ls ./projects
      </div>
      <h2 className="section-title">Things I've shipped</h2>
      <p className="section-sub">
        A few projects worth a closer look — built end to end, from schema to deploy.
      </p>

      <div className="proj-grid reveal-stagger">
        <div className="proj-card">
          <span className="proj-kicker">{'// real estate · mobile'}</span>
          <h3 className="proj-title">HomeBase</h3>
          <p className="proj-desc">
            A real estate app for browsing, renting, buying, and selling homes — complete with a custom
            design system and animated onboarding flow.
          </p>
          <div className="proj-tags">
            <span className="tag">React Native</span>
            <span className="tag">TypeScript</span>
          </div>
          <div className="proj-links">
            <a href="https://github.com/Hck3r1/HomeBase" target="_blank" rel="noopener noreferrer">
              ↳ GitHub
            </a>
          </div>
        </div>

        <div className="proj-card">
          <span className="proj-kicker">{'// edtech · frontend'}</span>
          <h3 className="proj-title">MIC LMS — Frontend</h3>
          <p className="proj-desc">
            Learning Management System frontend built during NYSC, letting IT students track tasks and
            progress in one place.
          </p>
          <div className="proj-tags">
            <span className="tag">React</span>
            <span className="tag">Vercel</span>
          </div>
          <div className="proj-links">
            <a href="https://mic-lms.vercel.app" target="_blank" rel="noopener noreferrer">
              ↳ Live
            </a>
            <a href="https://github.com/Hck3r1/MIC-LMS" target="_blank" rel="noopener noreferrer">
              ↳ GitHub
            </a>
          </div>
        </div>

        <div className="proj-card">
          <span className="proj-kicker">{'// edtech · API'}</span>
          <h3 className="proj-title">MIC LMS — Backend</h3>
          <p className="proj-desc">
            The REST API behind MIC LMS — handles task assignment, submission tracking, and grading for IT
            students.
          </p>
          <div className="proj-tags">
            <span className="tag">Node.js</span>
            <span className="tag">Render</span>
          </div>
          <div className="proj-links">
            <a
              href="https://lms-backend-u90k.onrender.com/api-docs/"
              target="_blank"
              rel="noopener noreferrer"
            >
              ↳ API Docs
            </a>
            <a
              href="https://github.com/Hck3r1/MIC-LMS-backend"
              target="_blank"
              rel="noopener noreferrer"
            >
              ↳ GitHub
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Projects;
